var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _rect, _rect2, _path11, _path12, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 252,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7C0.5 3.13401 3.63401 0 7.5 0H335.5C339.366 0 342.5 3.13401 342.5 7V252H0.5V7Z",
    fill: "#F3F7FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8191_7193",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 343,
    height: 252
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7C0.5 3.13401 3.63401 0 7.5 0H335.5C339.366 0 342.5 3.13401 342.5 7V252H0.5V7Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8191_7193)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.138 139.954C117.366 139.952 113.498 135.623 113.5 130.282L113.522 84.6621C113.523 79.3247 117.395 74.9986 122.166 75L225.864 75.0443C230.635 75.0474 234.502 79.3749 234.5 84.7173L234.483 130.334C234.48 135.673 230.607 140.002 225.835 140L122.138 139.954Z",
    fill: "#262B37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.527 77L129.5 136.962L211.5 137V77.0356L129.527 77Z",
    fill: "#FCFEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.5 77.0048L210.5 77V136.995L221.473 137L221.5 77.0048Z",
    fill: "#DDDCDB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.5 107.5C219.5 109.433 217.933 111 216 111C214.067 111 212.5 109.433 212.5 107.5C212.5 105.567 214.067 104 216 104C217.933 104 219.5 105.567 219.5 107.5",
    fill: "#ECECEC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.5 131.5C219.5 133.433 217.933 135 216 135C214.067 135 212.5 133.433 212.5 131.5C212.5 129.567 214.067 128 216 128C217.933 128 219.5 129.567 219.5 131.5",
    fill: "#ECECEC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.928 107.005C215.655 107.045 215.465 107.299 215.505 107.572C215.545 107.845 215.799 108.034 216.072 107.995C216.345 107.955 216.534 107.701 216.495 107.428C216.455 107.155 216.201 106.965 215.928 107.005",
    fill: "#BABABA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.005 104.226C218.181 104.228 218.323 104.392 218.322 104.593L218.288 109.435C218.287 109.636 218.143 109.799 217.966 109.797L215.438 109.774C215.262 109.773 215.119 109.608 215.121 109.407L215.129 108.225L214.995 108.223C214.819 108.222 214.677 108.057 214.678 107.856L214.69 106.107C214.691 105.906 214.836 105.744 215.012 105.746L215.146 105.747L215.155 104.565C215.156 104.364 215.3 104.201 215.477 104.203L218.005 104.226ZM214.802 105.257L214.806 104.657L214.966 104.659L214.962 105.258L214.802 105.257ZM214.984 104.469L214.769 104.467C214.698 104.466 214.641 104.531 214.64 104.611L214.635 105.3C214.635 105.38 214.691 105.446 214.762 105.447L214.971 105.449L214.97 105.545C214.716 105.568 214.514 105.81 214.512 106.106L214.5 107.854C214.498 108.15 214.696 108.396 214.95 108.424L214.943 109.405C214.941 109.718 215.162 109.975 215.436 109.977L217.965 110C218.239 110.002 218.464 109.75 218.466 109.437L218.5 104.595C218.502 104.282 218.281 104.026 218.007 104.023L215.478 104C215.232 103.998 215.026 104.201 214.984 104.469V104.469Z",
    fill: "#BABABA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.221 109.813L215.229 109.189L214.779 109.187L214.771 109.811L215.221 109.813ZM215.5 109.147L215.492 109.858C215.491 109.937 215.397 110.001 215.283 110L214.706 109.997C214.592 109.996 214.499 109.931 214.5 109.853L214.508 109.142C214.509 109.063 214.603 108.999 214.717 109L215.294 109.003C215.408 109.004 215.501 109.068 215.5 109.147V109.147Z",
    fill: "#BABABA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.065 107.772C218.191 108.637 217.592 109.439 216.728 109.565C215.863 109.691 215.061 109.092 214.935 108.228C214.809 107.363 215.408 106.561 216.272 106.435C217.137 106.309 217.939 106.908 218.065 107.772M216.212 106.021C215.736 106.09 215.302 106.328 214.988 106.691C214.677 107.051 214.504 107.509 214.5 107.982C214.499 108.083 214.506 108.186 214.521 108.288C214.56 108.555 214.65 108.806 214.789 109.035C214.923 109.256 215.096 109.447 215.304 109.603C215.512 109.758 215.745 109.87 215.995 109.935C216.254 110.003 216.521 110.018 216.788 109.979C217.263 109.909 217.698 109.672 218.012 109.308C218.323 108.949 218.496 108.491 218.5 108.018C218.501 107.916 218.494 107.814 218.479 107.712C218.44 107.445 218.35 107.193 218.211 106.964C218.077 106.743 217.904 106.552 217.696 106.397C217.488 106.242 217.255 106.13 217.005 106.065C216.746 105.997 216.479 105.982 216.212 106.021",
    fill: "#BABABA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8191_7193",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -12,
    y: 0,
    width: 374,
    height: 287
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-11.5 287H361.5V0H-11.5V287Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8191_7193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.5 89H219.5V82H213.5V89Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.091 132.595C216.091 133.053 215.826 133.425 215.5 133.425C215.174 133.425 214.909 133.053 214.909 132.595V131.472C214.909 131.014 215.174 130.641 215.5 130.641C215.826 130.641 216.091 131.014 216.091 131.472V132.595ZM215.5 129.575C215.629 129.575 215.739 129.687 215.739 129.821C215.739 129.954 215.629 130.067 215.5 130.067C215.371 130.067 215.261 129.954 215.261 129.821C215.261 129.687 215.371 129.575 215.5 129.575V129.575ZM216.033 130.285C216.105 130.153 216.148 129.993 216.148 129.821C216.148 129.368 215.857 129 215.5 129C215.143 129 214.852 129.368 214.852 129.821C214.852 129.993 214.895 130.153 214.967 130.285C214.687 130.535 214.5 130.973 214.5 131.472V132.595C214.5 133.37 214.949 134 215.5 134C216.051 134 216.5 133.37 216.5 132.595V131.472C216.5 130.973 216.313 130.535 216.033 130.285V130.285Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.502 207.396L314.665 157.223C312.794 152.546 310.657 147.546 306.361 144.96C302.066 142.374 295.078 144.016 294.273 148.993C292.74 145.784 287.082 139.577 283.57 139.968C280.742 140.283 276.585 146.935 276.585 146.935C274.174 144.823 267.163 142.014 264.676 142.786C252.497 146.568 252.784 156.895 255.314 163.818L227.152 122.587C221.677 114.695 208.697 120.964 215.609 130.379L245.437 184.862C240.828 189.069 223.428 174.303 221.288 174.227C219.286 174.156 211.152 172.919 210.088 174.63C208.448 177.269 210.527 180.395 212.791 182.515C235.096 203.39 260.165 217.059 285.722 233.721C291.305 237.361 306.12 252.029 309.141 258C323.476 252.199 329.164 234.744 342.5 228.454L327.502 207.396Z",
    fill: "#F4C7A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.297 120.123C220.778 120.017 220.217 119.975 219.613 120.015C216.215 120.236 214.656 122.337 214.5 124.642L218.075 130.618C218.662 130.855 219.311 130.992 220.016 131C219.963 130.996 220.229 130.971 220.45 130.953C223.629 130.514 225.235 128.42 225.5 126.179L221.297 120.123Z",
    fill: "#F4DED0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.281 76.6199C109.818 77.8934 120.692 78.1069 123.774 77.38C125.223 77.0155 125.783 76.9749 127.052 77.3382C128.139 77.5204 130.117 78.0799 131.567 78.262C133.561 78.6253 135.444 78.8075 137.438 78.262C140.7 77.3529 149.888 70.6082 143.002 68.9714C143.002 68.9714 114.429 60.9921 105.302 63.6967C94.8608 66.7911 73.0475 98.539 73.0475 98.539C73.0475 98.539 74.6024 83.1235 76.2993 80.8729C77.9973 78.6219 95.0114 64.0571 93.6028 53.2686C92.3751 43.8591 85.8665 47.1021 82.392 52.0624C78.9174 57.0222 67.0655 66.9229 63.9318 69.3888C60.7976 71.8556 55.3018 91.1177 55.3018 91.1177C55.3018 91.1177 54.8858 75.8121 57.1947 72.7257C59.5041 69.6378 69.6248 58.1096 68.8531 51.8221C68.0808 45.5358 62.7324 44.1054 60.3485 45.4767C57.9645 46.8475 50.515 60.1782 46.3756 63.5999C42.2354 67.0214 39.8036 71.8852 39.6118 77.8099C39.4212 83.7353 39.5027 99.3596 39.5027 99.3596C39.5027 99.3596 34.3825 92.8619 34.8027 89.91C35.2234 86.9573 41.4967 79.8502 37.8292 74.6533C32.2676 66.7714 30.5073 75.9919 28.6506 79.1597C26.7933 82.3288 22.1913 90.0194 22.5164 94.0508C22.8404 98.0822 36.2619 149.417 37.9653 153.034L31.9968 179.159L71.7608 194C71.7608 194 79.1174 168.797 81.7227 160.874C82.8541 157.433 85.5 158.688 88.099 157.979C94.8818 157.74 99.8086 155.643 106.592 156.276C109.31 156.458 112.391 157.549 115.11 157.004C119.279 156.095 122.904 153.73 127.253 153.002C132.691 152.275 141.209 153.002 137.584 145.181C134.503 138.452 122.722 139.906 116.56 139.906C110.216 139.906 103.873 141.908 97.3481 141.543C91.5483 141.18 89.5544 136.269 87.9231 131.176C84.9186 121.954 89.8414 114.287 93.1132 105.985L107.281 76.6199Z",
    fill: "#F4C7A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5472 50.9104C61.73 48.8318 62.4637 46.3803 63.5 44.1291C62.3566 43.8672 61.2587 44.0127 60.4858 44.4853C59.5059 45.0843 57.6328 47.9262 55.5 51.2507C57.3755 52.1534 59.7488 52.4595 60.5472 50.9104",
    fill: "#F4DED0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6158 50.2473C89.7395 48.9468 90.612 47.5313 91.5 46.138C88.7588 45.3894 85.1779 47.7892 82.8426 50.8333C82.475 51.3125 82.0214 51.8379 81.5 52.3978C81.9147 52.4626 82.3145 52.539 82.714 52.6961C85.1639 53.7164 87.1682 51.9817 88.6158 50.2473",
    fill: "#F4DED0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.824 68.8211C141.536 68.2503 139.025 68.1075 136.5 68C136.755 68.916 137.158 69.7024 137.866 69.9852C140.676 71.0369 143.524 71.7163 146.409 72C146.759 70.6151 146.14 69.423 143.824 68.8211",
    fill: "#F4DED0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.5 149C137.888 148.997 135.261 149.125 132.559 149.579C131.038 149.817 129.192 150.291 128.649 152.071C128.564 152.382 128.517 152.692 128.5 153C128.564 152.988 128.627 152.974 128.69 152.963C133.061 152.326 139.287 152.643 140.5 149",
    fill: "#F4DED0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4367 74.9472C32.9554 73.7689 33.4036 72.3737 33.5 71.0099C31.6422 70.8173 30.4767 73.4641 29.5 75.8487C30.672 76.0997 31.8807 76.1773 32.4367 74.9472",
    fill: "#F4DED0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6038 266L5.5 251.131L35.3962 157L82.5 171.869L52.6038 266Z",
    fill: "#FCFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5 177.206L30.018 159L-10.5 287H52.7452L87.5 177.206Z",
    fill: "#116C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.544 209L293.5 241.586L330.512 287H363.5V244.529L334.544 209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.532 210L293.5 248.036L324.675 287H361.5V236.206L340.532 210Z",
    fill: "#116C3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.177 175.001C211.125 175.034 209.364 177.314 209.508 178.403C209.733 180.097 213.908 184.65 216.141 182.377C217.561 180.932 214.463 174.929 212.177 175.001",
    fill: "#F4DED0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3528 104.36C57.585 105.875 57.3425 107.665 57.5976 109.435C57.7399 110.424 58.9083 110.005 58.7663 109.02C58.5699 107.656 58.8155 106.302 59.3993 105.149C59.8274 104.304 58.7785 103.519 58.3528 104.36",
    fill: "#D6A987"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3528 108.3C73.5849 109.563 73.3426 111.054 73.5976 112.53C73.74 113.353 74.9081 113.004 74.7661 112.183C74.5699 111.047 74.8153 109.918 75.3993 108.958C75.8274 108.254 74.7784 107.6 74.3528 108.3",
    fill: "#D6A987"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3318 108.702C45.5999 107.739 45.3658 106.288 45.7065 104.935C45.9418 104.002 44.9299 103.598 44.6967 104.524C44.2356 106.355 44.6058 108.498 45.5914 109.795C46.093 110.455 46.8362 109.366 46.3318 108.702",
    fill: "#D6A987"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3318 111.702C32.5999 110.739 32.3659 109.288 32.7065 107.935C32.9418 107.002 31.93 106.598 31.6967 107.524C31.2355 109.355 31.6058 111.498 32.5913 112.795C33.093 113.455 33.8361 112.366 33.3318 111.702",
    fill: "#D6A987"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.913 166.21C278.395 167.478 279.273 169.238 279.494 171.175C279.617 172.256 277.953 172.283 277.831 171.205C277.661 169.714 276.915 168.406 275.788 167.442C274.962 166.735 276.092 165.507 276.913 166.21",
    fill: "#D6A987"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.913 179.175C264.395 180.232 265.273 181.699 265.494 183.313C265.616 184.214 263.953 184.236 263.831 183.338C263.661 182.095 262.915 181.005 261.788 180.202C260.962 179.612 262.092 178.589 262.913 179.175",
    fill: "#D6A987"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.815 167.911C292.43 166.706 292.35 165.248 291.629 164.116C291.131 163.335 292.205 162.542 292.699 163.317C293.675 164.849 293.765 167.013 292.937 168.635C292.516 169.461 291.392 168.741 291.815 167.911",
    fill: "#D6A987"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.815 162.911C304.43 161.706 304.35 160.248 303.629 159.116C303.131 158.335 304.204 157.542 304.699 158.317C305.675 159.848 305.765 162.013 304.937 163.635C304.516 164.461 303.392 163.741 303.815 162.911",
    fill: "#D6A987"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1322 194.825C70.9386 194.125 71.349 193.401 72.0489 193.207C72.7488 193.014 73.4731 193.424 73.6669 194.124C73.8603 194.824 73.4499 195.548 72.7501 195.742C72.0503 195.935 71.3258 195.525 71.1322 194.825M67.3553 195.87C67.1617 195.17 67.572 194.446 68.2718 194.252C68.9718 194.059 69.6962 194.469 69.8898 195.169C70.0835 195.869 69.673 196.593 68.973 196.787C68.2732 196.98 67.5489 196.57 67.3553 195.87M75.3178 193.667C74.5817 191.006 71.8279 189.446 69.1671 190.182C66.5065 190.918 64.9461 193.672 65.6822 196.333C66.4183 198.994 69.1721 200.554 71.8329 199.818C74.4935 199.082 76.0539 196.328 75.3178 193.667",
    fill: "#FAFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1323 218.825C64.9385 218.125 65.3489 217.401 66.0491 217.207C66.7489 217.014 67.4732 217.424 67.6668 218.124C67.8604 218.824 67.4501 219.548 66.7501 219.742C66.0502 219.935 65.3259 219.525 65.1323 218.825M61.3552 219.87C61.1617 219.17 61.5721 218.446 62.2719 218.252C62.9719 218.059 63.6961 218.469 63.8898 219.169C64.0834 219.869 63.6731 220.593 62.9731 220.787C62.2733 220.98 61.5489 220.57 61.3552 219.87M69.3178 217.667C68.5819 215.006 65.828 213.446 63.1672 214.182C60.5063 214.918 58.9461 217.672 59.6822 220.333C60.4183 222.994 63.172 224.554 65.8328 223.818C68.4937 223.082 70.0539 220.328 69.3178 217.667",
    fill: "#FAFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.971 258.81C313.273 259.011 312.545 258.609 312.343 257.911C312.142 257.214 312.544 256.485 313.242 256.283C313.939 256.082 314.668 256.484 314.87 257.182C315.071 257.88 314.669 258.608 313.971 258.81M317.736 257.723C317.039 257.924 316.31 257.522 316.108 256.824C315.907 256.127 316.309 255.398 317.007 255.196C317.705 254.995 318.433 255.397 318.635 256.095C318.836 256.793 318.434 257.522 317.736 257.723M316.886 261.803C319.539 261.037 321.068 258.266 320.303 255.614C319.537 252.961 316.766 251.432 314.114 252.197C311.461 252.963 309.932 255.734 310.697 258.386C311.463 261.039 314.234 262.568 316.886 261.803",
    fill: "#FAFCFC"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 89,
    width: 63,
    height: 37,
    rx: 3,
    fill: "#DFE8F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 166.5,
    y: 100,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "#F3F3F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152 101C152.962 101 153.794 100.655 154.475 99.9746C155.155 99.2942 155.5 98.4617 155.5 97.4999C155.5 96.5384 155.155 95.7058 154.475 95.0252C153.794 94.3449 152.962 94 152 94C151.038 94 150.206 94.3449 149.525 95.0253C148.845 95.7057 148.5 96.5383 148.5 97.4999C148.5 98.4617 148.845 99.2943 149.525 99.9747C150.206 100.655 151.039 101 152 101Z",
    fill: "#96CD00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.468 105.424C158.447 105.123 158.405 104.794 158.342 104.447C158.279 104.097 158.198 103.766 158.1 103.464C157.999 103.151 157.862 102.842 157.693 102.547C157.517 102.24 157.311 101.972 157.08 101.752C156.837 101.522 156.541 101.337 156.198 101.202C155.856 101.068 155.478 101 155.073 101C154.914 101 154.76 101.065 154.463 101.257C154.28 101.375 154.066 101.512 153.827 101.664C153.623 101.793 153.347 101.914 153.005 102.024C152.672 102.131 152.334 102.185 152 102.185C151.666 102.185 151.327 102.131 150.994 102.024C150.653 101.914 150.376 101.793 150.172 101.664C149.936 101.514 149.722 101.377 149.536 101.257C149.24 101.065 149.086 101 148.927 101C148.521 101 148.143 101.068 147.801 101.202C147.459 101.337 147.162 101.522 146.92 101.753C146.688 101.973 146.482 102.24 146.306 102.547C146.137 102.842 146 103.151 145.899 103.464C145.802 103.766 145.721 104.097 145.657 104.447C145.595 104.794 145.552 105.123 145.531 105.425C145.51 105.721 145.5 106.028 145.5 106.339C145.5 107.146 145.759 107.8 146.268 108.283C146.772 108.759 147.438 109 148.249 109H155.751C156.562 109 157.228 108.759 157.731 108.283C158.241 107.801 158.5 107.147 158.5 106.338C158.5 106.027 158.489 105.719 158.468 105.424Z",
    fill: "#96CD00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 166.5,
    y: 95,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "#F3F3F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 166.5,
    y: 106,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "#F3F3F3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 166.5,
    y: 112,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPhoto);
export default __webpack_public_path__ + "static/media/document_photo.331406d5a38deb72668cd9380e60578a.svg";
export { ForwardRef as ReactComponent };